import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ documentData, userid, username, callbackUrl }) =>
    present(
      repository
        .retrieveDocumentEditionToken(
          documentData,
          username,
          userid,
          callbackUrl,
        )
        .then((res) => {
          return {
            documentData,
            username,
            userid,
            callbackUrl,
            token: res.token,
          };
        })
        .catch(() =>
          Promise.reject({
            documentData,
            username,
            userid,
            callbackUrl,
          }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
